let width = window.innerWidth - document.documentElement.clientWidth;
const root = document.documentElement;

// Doing a sanity check for scroll bar width value because on mobile devices it
// can return strange values and therefore break the page layout.
if (width === 0 || width > 30) {
  width = 0;
}

root.style.setProperty('--scrollbar-width', `${width}px`);
document.documentElement.classList.add('has-scrollbar-width-set');
